import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient, ConvertParamsToFormData } from "~/utils";

import {
  ApiManagersMeetingNoteMutateType,
  RawDraftContentState,
} from "~/domains";

type RequestDataType = {
  body: {
    title: string;
    content: RawDraftContentState;
    postDate: string;
    meetingNoteTemplateId?: string;
    attachFiles?: File[];
    participationEmployeeIds: string[];
    businessSectionIds: string[];
  };
};

const request = ({ body }: RequestDataType) => {
  const formData = ConvertParamsToFormData({ meetingNote: body });
  return new ApiClient()
    .post<ApiManagersMeetingNoteMutateType>(
      "/api/managers/meeting_notes",
      formData,
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisManagersMeetingNotesCreate = ({
  options = {},
}: PropsType = {}): UseMutationResult<
  ApiManagersMeetingNoteMutateType,
  RequestDataType
> => {
  return useMutation(request, { ...options });
};
